import MdaeButton from './component';
import { IButtonOptions } from 'devextreme-react/button';

export const mandatoryPropNames = ['id', 'role'];
export interface IMdaeButtonProps extends IButtonOptions {
  id: string;
  role: 'action' | 'primary' | 'secondary' | 'dxButton';
  isAnayticsTabSection?: boolean;
  mdaeIcon?: any;
  onClick?: any;
  icon?: string;
  fontAwesomeIcon?: any;
  text?: string;
}
export default MdaeButton;
